import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertOctagon, AlertCircle, ArrowRight } from "lucide-react";

export default function Alertas() {
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("all");

    useEffect(() => {
        api.get("/alerts-ext").then(r => setAlerts(r.data)).finally(() => setLoading(false));
    }, []);

    const criticos = alerts.filter(a => a.nivel === "critico");
    const atencoes = alerts.filter(a => a.nivel === "atencao");
    const filtered = filter === "all" ? alerts : alerts.filter(a => a.nivel === filter);

    return (
        <div className="space-y-6 fade-in" data-testid="alertas-page">
            <header>
                <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-medium">Customer Success</div>
                <h1 className="font-display font-bold text-3xl text-[#0F2044] mt-1">Alertas</h1>
                <p className="text-sm text-slate-500 mt-1">Sinais automáticos baseados em uso, jornada, score e prazos contratuais.</p>
            </header>

            <div className="grid grid-cols-3 gap-4">
                <Card title="Críticos" value={criticos.length} color="#EF4444" onClick={() => setFilter("critico")} active={filter === "critico"} testid="kpi-criticos-page" />
                <Card title="Atenção" value={atencoes.length} color="#F59E0B" onClick={() => setFilter("atencao")} active={filter === "atencao"} testid="kpi-atencao-page" />
                <Card title="Total" value={alerts.length} color="#0F2044" onClick={() => setFilter("all")} active={filter === "all"} testid="kpi-all-page" />
            </div>

            {loading ? (
                <div className="text-sm text-slate-500">Carregando alertas…</div>
            ) : filtered.length === 0 ? (
                <div className="bg-white border border-slate-200 rounded-lg p-10 text-center text-sm text-slate-500">
                    Nenhum alerta para o filtro selecionado. 🎉
                </div>
            ) : (
                <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
                    <ul className="divide-y divide-slate-100">
                        {filtered.map((a, i) => (
                            <li key={i} className="px-5 py-4 flex items-start gap-3 hover:bg-slate-50" data-testid={`alert-row-${i}`}>
                                <div className={`h-9 w-9 rounded-md flex items-center justify-center flex-shrink-0 ${a.nivel === "critico" ? "bg-red-100" : "bg-amber-100"}`}>
                                    {a.nivel === "critico"
                                        ? <AlertOctagon className="h-5 w-5 text-red-600" />
                                        : <AlertCircle className="h-5 w-5 text-amber-600" />}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <Link to={`/contratos/${a.contract_id}`} className="text-sm font-semibold text-[#0F2044] hover:underline" data-testid={`alert-link-${a.contract_id}-${i}`}>
                                        {a.organizacao_nome}
                                    </Link>
                                    <div className="text-sm text-slate-700 mt-0.5">{a.gatilho}</div>
                                    <div className="text-xs text-slate-500 mt-0.5">Ação sugerida: {a.acao}</div>
                                </div>
                                <Link to={`/contratos/${a.contract_id}`} className="text-xs text-[#0F2044] hover:underline whitespace-nowrap flex items-center gap-1">
                                    Acessar <ArrowRight className="h-3 w-3" />
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

function Card({ title, value, color, onClick, active, testid }) {
    return (
        <button onClick={onClick} data-testid={testid} className={`text-left bg-white border rounded-lg p-5 transition-all ${active ? "border-[#0F2044] shadow-md" : "border-slate-200 hover:border-slate-300"}`}>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">{title}</div>
            <div className="flex items-baseline gap-2 mt-2">
                <div className="text-4xl font-display font-bold" style={{ color }}>{value}</div>
                <div className="text-xs text-slate-400">alerta(s)</div>
            </div>
        </button>
    );
}
